var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "locations"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.7334 29.1924C11.8074 29.2664 11.8952 29.3251 11.9919 29.3651C12.0886 29.4052 12.1922 29.4258 12.2968 29.4258C12.4015 29.4258 12.5051 29.4052 12.6018 29.3651C12.6985 29.3251 12.7863 29.2664 12.8603 29.1924L19.7906 22.2622C26.3286 15.6863 21.4001 4.62395 12.2968 4.54785C3.2492 4.55072 -1.73447 15.7713 4.80319 22.2623L11.7334 29.1924ZM5.92989 8.93586C14.1716 0.549548 26.6629 12.6536 18.6637 21.1355L12.2969 27.5021L5.92989 21.1354C4.31454 19.5164 3.40735 17.3227 3.40735 15.0356C3.40735 12.7486 4.31454 10.5549 5.92989 8.93586Z",
    fill: "#395723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.7032 27.5015L19.8114 25.6141C19.6611 25.4684 19.4595 25.3877 19.2502 25.3895C19.0409 25.3912 18.8407 25.4752 18.6928 25.6234C18.5449 25.7715 18.4613 25.9719 18.4599 26.1812C18.4586 26.3905 18.5397 26.5919 18.6856 26.742L21.1406 29.1917C21.29 29.3409 21.4925 29.4247 21.7036 29.4247C21.9147 29.4247 22.1172 29.3409 22.2666 29.1917L29.1552 22.3083C36.0249 15.4391 30.2225 3.66574 20.6636 4.62666C20.4554 4.65033 20.2649 4.75509 20.1333 4.91825C20.0018 5.0814 19.9398 5.28981 19.9609 5.49833C19.9819 5.70685 20.0843 5.89868 20.2457 6.03227C20.4072 6.16586 20.6148 6.23045 20.8236 6.21205C28.9039 5.40523 33.8458 15.3645 28.028 21.1815L21.7032 27.5015ZM12.2969 19.6998C13.5335 19.6984 14.7192 19.2065 15.5936 18.332C16.4681 17.4576 16.96 16.2719 16.9614 15.0352C16.7167 8.8516 7.87606 8.85334 7.63232 15.0353C7.63372 16.272 8.12561 17.4576 9.00008 18.3321C9.87455 19.2065 11.0602 19.6984 12.2969 19.6998ZM12.2969 11.9645C16.3551 12.0935 16.3541 17.9776 12.2968 18.106C8.23863 17.977 8.23959 12.0929 12.2969 11.9645Z",
    fill: "#395723"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocations);
export default __webpack_public_path__ + "static/media/locations.05152006f9b4c244f59833cb6752d718.svg";
export { ForwardRef as ReactComponent };